function show_hide_password() {
  $(".show_hide_password").click(function () {
      "password" == $('.ced_password').attr("type")
          ? ($('.ced_password').attr("type", "text"), $(this).children(".hide_password").hide(), $(this).children(".show_password").show())
          : ($('.ced_password').attr("type", "password"), $(this).children(".hide_password").show(), $(this).children(".show_password").hide());
  });
}
function validate_forms() {
    let t = $("[data-submit]"),
        a = $(".ced_email"),
        e = $(".ced_name"),
        s = $(".ced_last_name"),
        d = $(".ced_password"),
        n = $(".ced_confirm_password"),
        l = $(".ced_address"),
        i = $(".ced_phone"),
        c = $(".ced_city"),
        r = $(".ced_country"),
        o = $(".ced_zip_code"),
        _ = $(".ced_email_error"),
        u = $(".ced_name_error"),
        p = $(".ced_last_name_error"),
        h = $(".ced_password_error"),
        m = $(".ced_confirm_password_error"),
        b = $(".ced_phone_error"),
        f = $(".ced_address_error"),
        w = $(".ced_city_error"),
        v = $(".ced_country_error"),
        y = $(".ced_zip_code_error");
    t.attr("disabled", "disabled"),
        null != a
            ? a.on("input blur", function () {
                  validate_details(_, "email", t);
              })
            : console.log("no email feild"),
        null != e &&
            e.on("input blur", function () {
                validate_details(u, "name", t);
            }),
        null != s &&
            s.on("input blur", function () {
                validate_details(p, "last_name", t);
            }),
        null != i &&
            i.on("input blur", function () {
                validate_details(b, "phone", t);
            }),
        null != d &&
            d.on("input blur", function () {
                validate_details(h, "password", t);
            }),
        null != n &&
            n.on("input blur", function () {
                validate_details(m, "confirm_password", t);
            }),
        null != l &&
            l.on("input blur", function () {
                validate_details(f, "address", t);
            }),
        null != c &&
            c.on("input blur", function () {
                validate_details(w, "city", t);
            }),
        null != r &&
            r.on("change", function () {
                validate_details(v, "country", t);
            }),
        null != o &&
            o.on("input blur", function () {
                validate_details(y, "zip_code", t);
            });
}
function validate_details(t, a, e) {
    if (
        ("email" == a &&
            ((email = $(".ced_email").val()),
            "" == email
                ? (t.text("**Email Cannot be Blank"), $(".ced_email").attr("data-status", !1), e.attr("disabled", "disabled"))
                : !email.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/) || email.match(/^[0-9]/)
                ? (t.text("**Invalid Email format"), $(".ced_email").attr("data-status", !1), e.attr("disabled", "disabled"))
                : (t.text(""), $(".ced_email").attr("data-status", !0), check_status(e))),
        "name" == a)
    )
        if (((name = $(".ced_name").val()), "" == name)) t.text("**Name cannot be blank"), $(".ced_name").attr("data-status", !1), e.attr("disabled", "disabled");
        else if (name.match(/^[A-Za-z\s\-]+$/))
            name.length < 3 ? (t.text("**Name cannot be less than 3 characters"), $(".ced_name").attr("data-status", !1), e.attr("disabled", "disabled")) : (t.text(""), $(".ced_name").attr("data-status", !0), check_status(e));
        else {
            if (1 == name.length) $(".ced_name").val("");
            else {
                var s = name.slice(0, -1);
                $(".ced_name").val(s);
            }
            setTimeout(function () {
                t.text(""), validate_details(t, "name");
            }, 3e3),
                t.text("**Name cannot contain numbers or special characters"),
                $(".ced_name").attr("data-status", !1),
                e.attr("disabled", "disabled");
        }
    if ("last_name" == a)
        if (((last_name = $(".ced_last_name").val()), "" == last_name)) t.text(""), $(".ced_last_name").attr("data-status", !0), check_status(e);
        else if (last_name.match(/^[A-Za-z\s\-]+$/)) t.text(""), $(".ced_last_name").attr("data-status", !0), check_status(e);
        else {
            if (1 == last_name.length) $(".ced_last_name").val("");
            else {
                s = last_name.slice(0, -1);
                $(".ced_last_name").val(s);
            }
            setTimeout(function () {
                t.text(""), validate_details(last_name_error, "last_name");
            }, 3e3),
                t.text("**Last name should contain only alphabets"),
                $(".ced_last_name").attr("data-status", !1),
                e.attr("disabled", "disabled");
        }
    if ("phone" == a)
        if (((phone = $(".ced_phone").val()), "" == phone)) t.text("**Phone Number cannot be blank"), $(".ced_phone").attr("data-status", !1), e.attr("disabled", "disabled");
        else if (1 == phone.length && "0" == phone) $(".ced_phone").val(""), t.text("**Phone Number cannot begin with 0"), $(".ced_phone").attr("data-status", !1), e.attr("disabled", "disabled");
        else if (phone.match(/^[0-9]+$/))
            if (phone.length < 10) t.text("**Phone number cannot be less than 10 digits"), $(".ced_phone").attr("data-status", !1), e.attr("disabled", "disabled");
            else if (phone.length > 10) {
                d = phone.slice(0, -1);
                $(".ced_phone").val(d),
                    t.text("**Phone number cannot be more than 10 digits"),
                    setTimeout(function () {
                        t.text(""), validate_details(t, "phone");
                    }, 3e3),
                    $(".ced_phone").attr("data-status", !1),
                    e.attr("disabled", "disabled");
            } else t.text(""), $(".ced_phone").attr("data-status", !0), check_status(e);
        else {
            if (1 == phone.length && "0" != phone) $(".ced_phone").val("");
            else {
                var d = phone.slice(0, -1);
                $(".ced_phone").val(d);
            }
            t.text("**Phone number cannot contain alphabets or special characters"),
                setTimeout(function () {
                    t.text(""), validate_details(t, "phone");
                }, 3e3),
                $(".ced_phone").attr("data-status", !1),
                e.attr("disabled", "disabled");
        }
    if (
        ("password" == a &&
            ((password = $(".ced_password").val()),
            "" == password
                ? (t.text("**Password Cannot be Blank"), $(".ced_password").attr("data-status", !1), e.attr("disabled", "disabled"))
                : password.length < 8
                ? (t.text("**Password cannot be less than 8 characters"), $(".ced_password").attr("data-status", !1), e.attr("disabled", "disabled"))
                : (t.text(""), $(".ced_password").attr("data-status", !0), check_status(e))),
        "confirm_password" == a &&
            ((password = $(".ced_confirm_password").val()),
            "" == password
                ? (t.text("**Confirm Password Cannot be Blank"), $(".ced_confirm_password").attr("data-status", !1), e.attr("disabled", "disabled"))
                : password.length < 8
                ? (t.text("**Confirm Password cannot be less than 8 characters"), $(".ced_confirm_password").attr("data-status", !1), e.attr("disabled", "disabled"))
                : password != $(".ced_password").val()
                ? (t.text("**Confirm Password and Password should be same"), $(".ced_confirm_password").attr("data-status", !1), e.attr("disabled", "disabled"))
                : (t.text(""), $(".ced_confirm_password").attr("data-status", !0), check_status(e))),
        "city" == a)
    )
        if (((city = $(".ced_city").val()), "" == city)) t.text("**City cannot be blank"), $(".ced_city").attr("data-status", !1), e.attr("disabled", "disabled");
        else if (city.match(/^[A-Za-z\s\-]+$/))
            city.length < 3 ? (t.text("**City cannot be less than 3 characters"), $(".ced_city").attr("data-status", !1), e.attr("disabled", "disabled")) : (t.text(""), $(".ced_city").attr("data-status", !0), check_status(e));
        else {
            if (1 == city.length) $(".ced_city").val("");
            else {
                var n = city.slice(0, -1);
                $(".ced_city").val(n);
            }
            setTimeout(function () {
                t.text(""), validate_details(t, "address");
            }, 3e3),
                t.text("**City cannot contain numbers or special characters"),
                $(".ced_city").attr("data-status", !1),
                e.attr("disabled", "disabled");
        }
    if (
        ("address" == a &&
            ((address = $(".ced_address").val()),
            "" == address
                ? (t.text("**Address Cannot be Blank"), $(".ced_address").attr("data-status", !1), e.attr("disabled", "disabled"))
                : address.length < 3
                ? (t.text("**Address cannot be less than 3 characters"), $(".ced_address").attr("data-status", !1), e.attr("disabled", "disabled"))
                : (t.text(""), $(".ced_address").attr("data-status", !0), check_status(e))),
        "country" == a &&
            ((country = $(".ced_country").val()),
            "---" == country ? (t.text("**Country Cannot be Blank"), $(".ced_country").attr("data-status", !1), e.attr("disabled", "disabled")) : (t.text(""), $(".ced_country").attr("data-status", !0), check_status(e))),
        "zip_code" == a)
    )
        if (((zip_code = $(".ced_zip_code").val()), "" == zip_code)) t.text("**Zip code cannot be blank"), $(".ced_zip_code").attr("data-status", !1), e.attr("disabled", "disabled");
        else if (zip_code.match(/^[0-9-a-z-A-Z]+$/))
            zip_code.length < 3 ? (t.text("**Zip Code cannot be less than 3 digits"), $(".ced_zip_code").attr("data-status", !1), e.attr("disabled", "disabled")) : (t.text(""), $(".ced_zip_code").attr("data-status", !0), check_status(e));
        else {
            if (1 == zip_code.length) $(".ced_zip_code").val("");
            else {
                var l = zip_code.slice(0, -1);
                $(".ced_zip_code").val(l);
            }
            t.text("**Zip Code cannot contain alphabets or special characters"),
                setTimeout(function () {
                    t.text(""), validate_details(t, "zip_code");
                }, 3e3),
                $(".ced_zip_code").attr("data-status", !1),
                e.attr("disabled", "disabled");
        }
}
function check_status(t) {
    var a = { name_status: "", last_name_status: "", email_status: "", phone_status: "", password_status: "", confirm_passoword_status: "", address_status: "", city_status: "", zip_code_status: "", country_status: "" };
    (null == $(".ced_name") && null == $(".ced_name")) || (a.name_status = $(".ced_name").attr("data-status")),
        (null == $(".ced_last_name") && null == $(".ced_last_name")) || (a.last_name_status = $(".ced_last_name").attr("data-status")),
        (null == $(".ced_email") && null == $(".ced_email")) || (a.email_status = $(".ced_email").attr("data-status")),
        (null == $(".ced_phone") && null == $(".ced_phone")) || (a.phone_status = $(".ced_phone").attr("data-status")),
        (null == $(".ced_password") && null == $(".ced_password")) || (a.password_status = $(".ced_password").attr("data-status")),
        (null == $(".ced_confirm_password") && null == $(".ced_confirm_password")) || (a.confirm_passoword_status = $(".ced_confirm_password").attr("data-status")),
        (null == $(".ced_address") && null == $(".ced_address")) || (a.address_status = $(".ced_address").attr("data-status")),
        (null == $(".ced_city") && null == $(".ced_city")) || (a.city_status = $(".ced_city").attr("data-status")),
        (null == $(".ced_zip_code") && null == $(".ced_zip_code")) || (a.zip_code_status = $(".ced_zip_code").attr("data-status")),
        (null == $(".ced_country") && null == $(".ced_country")) || (a.country_status = $(".ced_country").attr("data-status"));
    var e = 0,
        s = 0;
    for (individual_status in (console.log(a), a)) (null == a[individual_status] && null == a[individual_status]) || ((e += 1), "true" == a[individual_status] && (s += 1));
    e == s && t.removeAttr("disabled");
}
function forgot_password_validation() {
    var t = $("[data-fp-btn]");
    t.attr("disabled", "disabled"),
        $(".RecoverEmail").on("input blur", function () {
            var a = $(this).val(),
                e = $(".RecoverEmail_error");
            "" == a
                ? (e.html("**Email cannot be blank"), t.attr("disabled", "disabled"))
                : !a.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/) || a.match(/^[0-9]/)
                ? (e.html("**Invalid email address"), t.attr("disabled", "disabled"))
                : (e.html(""), t.removeAttr("disabled"));
        });
}
$(document).ready(function () {
    validate_forms(), show_hide_password(), forgot_password_validation();
});
